<template>
  <div>
    <b-form-group class="input-group-var-hospital" label="Hospital:" label-size="sm" label-for="input-var-hospital"  label-cols="4">
      <b-form-select required size="sm" id="input-var-hospital" class="var-hospital" v-model="hospital" :options="opcionsHospital" @input="onUpdateHospital">
        <template v-slot:first>
          <b-form-select-option :value="null">Totes</b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "VariableHospital",
  props: {
    initialValue:{
      required: true
    }
  },
  data() {
    return {
      codiVariable : 'hospital',
      hospital: null,
      opcionsHospital:[
        { value: '1', text: 'Hospital U. Arnau de Vilanova de Lleida' },
        { value: '39', text: 'Hospital Univ.  Joan XXIII de Tarragona' },
        { value: '86', text: 'Hospital de Tortosa Verge de la Cinta' },
        { value: '100', text: 'Hospital U de Girona Doctor Josep Trueta' },
        { value: '146', text: 'Hospital de Viladecans' },
        { value: '148', text: 'Hospital Universitari de Bellvitge' },
        { value: '272', text: 'H. U. Germans Trias i Pujol de Badalona' },
        { value: '634', text: 'Althaia' },
        { value: '707', text: 'Espitau Val d\'Aran' },
        { value: '718', text: 'Hospital Clínic de Barcelona' },
        { value: '719', text: 'Hospital Comarcal de Blanes' },
        { value: '723', text: 'Hospital de Campdevànol' },
        { value: '724', text: 'Hospital de Figueres' },
        { value: '725', text: 'Hospital General de Hospitalet' },
        { value: '726', text: 'Hospital Dos de Maig' },
        { value: '729', text: 'Hospital Universitari Mútua de Terrassa' },
        { value: '732', text: 'Fundació Sant Hospital' },
        { value: '734', text: 'Fundació Hospital de l\'Esperit Sant' },
        { value: '737', text: 'Hospital Comarcal Móra d\'Ebre' },
        { value: '739', text: 'Hospital de Palamós' },
        { value: '741', text: 'Hospital de Sabadell' },
        { value: '742', text: 'Parc Sanitari Sant  Joan Déu - HG' },
        { value: '743', text: 'Hospital de Sant Celoni' },
        { value: '744', text: 'Hospital de Terrassa' },
        { value: '745', text: 'Hospital Universitari de Vic' },
        { value: '746', text: 'Hospital del Mar ' },
        { value: '748', text: 'Hospital Comarcal del Pallars' },
        { value: '750', text: 'Hospital General de Granollers' },
        { value: '753', text: 'Hospital Municipal de Badalona' },
        { value: '754', text: 'Hospital Residència Sant Camil' },
        { value: '756', text: 'H. Sant Antoni Abat - Urgències' },
        { value: '757', text: 'Hospital Comarcal de Sant Bernabé' },
        { value: '759', text: 'HC Sant Jaume Calella' },
        { value: '762', text: 'Hosp. d\'Olot i Comarcal de la Garrotxa' },
        { value: '763', text: 'Hospital Universitari Sant Joan de Reus' },
        { value: '764', text: 'Hospital Sant Joan de Déu (Martorell)' },
        { value: '765', text: 'Hospital Sant Joan de Déu (Esplugues Ll)' },
        { value: '767', text: 'Hospital Sant Pau i Santa Tecla' },
        { value: '770', text: 'Hospital Santa Caterina' },
        { value: '772', text: 'Hospital de la Santa Creu i Sant Pau' },
        { value: '777', text: 'Fundació Puigvert - IUNA' },
        { value: '826', text: 'Pius Hospital de Valls' },
        { value: '833', text: 'Hospital Universitari Sagrat Cor' },
        { value: '836', text: 'Clínica Terres de l\'Ebre' },
        { value: '908', text: 'Hospital de Mollet' },
        { value: '916', text: 'Hospital d\'Igualada' },
        { value: '975', text: 'Hospital Comarcal d\'Amposta' },
        { value: '1012', text: 'Hospital Comarcal de l\'Alt Penedès' },
        { value: '1425', text: 'Hospital de Mataró' },
        { value: '4373', text: 'Hospital del Vendrell' },
        { value: '5994', text: 'H. Moisès Broggi' },
        { value: '6046', text: 'Hospital Universitari Vall d\'Hebron' },
        { value: '7493', text: 'Hospital de la Cerdanya' }
      ]
    };
  },
  computed:{
    returnValue(){
      let r = {codi: this.codiVariable}
      if(this.hospital!=null ){
        r.valor = this.hospital;
      }

      return r;
    }
  },
  methods: {
    onUpdateHospital(newValue){
      console.log(newValue)
      if(this.returnValue.valor){
        this.$emit('variable-editada', this.returnValue)
      }else{
        this.$emit('variable-eliminada', this.codiVariable)
      }
    }
  },
  mounted() {
    if(this.initialValue!=null){
      this.hospital = this.initialValue.valor
    }
  }
};
</script>

<style>
.var-hospital{
  width: 180px;
}
.input-group-var-hospital .col{
  text-align: left;
}
</style>